import { Component } from '@angular/core';
import { GatewayAPIService } from '../../../core/gateway-api.service';

@Component({
  selector: 'app-cron-page',
  templateUrl: './cron-page.component.html',
  standalone: false,
})
export class CronPageComponent {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(private api: GatewayAPIService) {}

  runRecurringBillingCron() {
    this.api
      .apiCallGateway(
        '/scheduled/recurring',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        null,
        this.options,
      )
      .then((response: any) => {
        console.log('Response:', response);
      });
  }

  runFiservDataImportCron() {
    this.api
      .apiCallGateway(
        '/scheduled/fiservimport',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        null,
        this.options,
      )
      .then((response: any) => {
        console.log('Response:', response);
      });
  }
}
